// extracted by mini-css-extract-plugin
module.exports = {"container":"we88-seasonal-promotion-slider_container__hU9es"};